import React from 'react';

import {AttachOverlay, PopoverForm} from 'app/general/overlays';
import {gt} from 'app/utils/i18n';

import {CreateFolderForm} from './CreateFolder';

import type {OverlayProps} from 'app/general/overlays';
import type {
  BasicTeamSerializedType,
  FolderHashidSerializedType,
  FolderSerializedType,
  RawFolderSerializedType,
} from 'sweet-types';

interface CreateFolderFormProps {
  onCreate?: (folder: RawFolderSerializedType) => any;
  parent: FolderHashidSerializedType | FolderSerializedType | null;
  teams?: Array<BasicTeamSerializedType>;
  autoFocus?: boolean;
}

interface CreateFolderPopoverProps extends CreateFolderFormProps {
  overlayProps: OverlayProps;
  onCancel: () => void;
}

export const CreateFolderPopover = ({
  overlayProps,
  onCreate,
  ...other
}: CreateFolderPopoverProps) => (
  <PopoverForm overlayProps={overlayProps}>
    {({closeOnSuccess}) => (
      <CreateFolderForm
        {...other}
        inPopover={true}
        onCreate={(folder) =>
          closeOnSuccess(onCreate ? onCreate(folder) : () => null)
        }
      />
    )}
  </PopoverForm>
);

export const CreateFolderOverlay = (props: CreateFolderFormProps) => (
  <AttachOverlay
    trigger="click"
    overlay={({overlayProps}) => (
      <CreateFolderPopover
        overlayProps={{
          ...overlayProps,
          placement: 'top',
        }}
        {...props}
        onCancel={() => overlayProps.toggle()}
      />
    )}
  >
    {(triggers) => (
      <button
        className="btn btn-link btn-sm pl-0 d-flex py-2 w-100"
        {...triggers}
      >
        <div style={{width: 32}}>
          <i className="fas fa-plus-circle" />
        </div>
        {gt('Add new Folder')}
      </button>
    )}
  </AttachOverlay>
);
